import { createAction } from '@reduxjs/toolkit';
import { UserBonus } from 'config/types/bonus/userBonus';

export const updateUserBonuses = createAction<{ userBonuses: UserBonus[] }>('bonus/updateUserBonuses');
export const updatePreparedBonusId = createAction<string>('bonus/updatePreparedBonusId');
export const resetUserBonus = createAction('bonus/resetUserBonus');
